import { useEffect, useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import * as THREE from 'three';

function CameraController({ target = [0, 0, 0] }) {
  const { camera } = useThree();
  const targetVector = useRef(new THREE.Vector3(...target));
  
  useEffect(() => {
    // Set initial camera look-at
    camera.lookAt(targetVector.current);
  }, [camera]);
  
  useFrame(() => {
    // Smooth camera look-at (for when target changes)
    const currentLookAt = new THREE.Vector3();
    camera.getWorldDirection(currentLookAt);
    currentLookAt.multiplyScalar(10).add(camera.position);
    
    currentLookAt.lerp(targetVector.current, 0.05);
    camera.lookAt(currentLookAt);
  });
  
  return null;
}

export default CameraController;